import React from "react";
import { t } from "../../../../dev/helpers/translator";
import Config from "../../../config/main";
import LanguageSwitcher from "../../components/languageSwitcher";
import Link from "react-router/es/Link";
import IndexLink from "react-router/es/IndexLink";
import Balance from '../../components/balance';
import Clock from "react-live-clock";
import SearchInheader from "../../components/searchInheader";
import NextRacing from "../../components/nextRacing";
import OddsSelector from './pieces/oddselector';
import CashdeskSubscriptionComponent from "../../components/cashdeskSubscriptionComponent";
import Helpers from "../../../helpers/helperFunctions";
import CasinoFavorites from "./pieces/casinoFavorit";
import loyalCardPic from '../../../images/loyalCard.png'
import { DepositModeEnum } from "../../../constants/enums/depositMode";

export default function headerTemplate() {
    let { user, location } = this.props,
        userId = user.profile?.id,
        depositMode = user.depositMode,
        userName = user.profile?.username,
        pathName = location.pathname;
    return <div className={`header-wrapper-t ${Helpers.isSplitScreenAvailable() ? 'split-screen-header' : ''}`}>
        {Config.terminal.enableAgeRestriction && <p className="over-18">{t("Prohibido apostar a menores de 18 años")}</p>}
        <div className="header-container-t">
            <div className="left-column-t">
                <div className="logo-wrapper">
                    <IndexLink to="/" className="logo-v" activeClassName="active" />
                    <IndexLink to="/" className="product-item-v home" activeClassName="active">
                        {Config.enableHeaderSectionName ? <span>{t('Home')}</span> : null}
                    </IndexLink>
                    {Config.nextRacingEnabled ? <NextRacing size="small" sportId={184} /> : null}
                    {Config.nextRacingEnabled ? <NextRacing size="small" sportId={31} /> : null}
                    {
                        Config.headerItems.map((item) => {
                            return item.enabled && !item.disabledInHeader &&
                                (item.iframeFullscreen
                                    // eslint-disable-next-line react/jsx-no-bind
                                    ? <div className={`product-item-v ${item.url}`} key={item.url} onClick={this.openPopupHandler(item.gameId)}>
                                        {item.name}
                                    </div>
                                    : <Link to={`/${item.url}`}
                                        className={`product-item-v ${item.url}`}
                                        activeClassName="active"
                                        key={item.url}>
                                        {Config.enableHeaderSectionName
                                            ? <span>{t(item.name)}</span>
                                            : Config.openSectionNameOnClick ? pathName.includes(item.url) && <span>{t(item.name)}</span> : null}
                                    </Link>);
                        })
                    }
                    {
                        Config.enableMultipleWinsPopup && !user.loggedInByRFID ? <a className={`product-item-v ticket`} onClick={this.props.openPopup("multipleTicketsPopup")}><span>{t(`Tickets`)}</span></a> : null
                    }
                </div>
            </div>
            <div className="right-column-t">
                <div className="nav-wrapper">
                    <LanguageSwitcher />
                    {
                        Config.main.subscribeToCashdesk && <CashdeskSubscriptionComponent />
                    }
                    <div className="mini-naw-contain">
                        <ul>
                            {
                                Config.enableCasinoFavorites && pathName === "/casino" && <CasinoFavorites pathName={location.pathname} />
                            }
                            {
                                user.loggedIn && <li>
                                    <div className={`single-nav-item ${this.state.userInfo && "active"}`} onClick={this.setHandleClick("userInfo")}>
                                        <p>
                                            <i className="arrow-v-nav profile-v" />
                                        </p>
                                        <div className="open-d-view">
                                            <ul>
                                                <li>{t("User Name: {1}", userName)}</li>

                                                <li>{"Id: " + userId}</li>
                                                {
                                                    (user.loggedIn || user.loggedInByRFID) && <li>
                                                        <div className="single-nav-item" onClick={this.props.openPopup("betHistory")}>
                                                            <p>{t("Bet History")}</p>
                                                        </div>
                                                    </li>
                                                }
                                                {
                                                    user.loggedInByRFID && Config.main.rfidPinCode && <li>
                                                        <div className="single-nav-item" onClick={this.changePinCode}>
                                                            <p>{t("CHANGE PIN CODE")}</p>
                                                        </div>
                                                    </li>
                                                }
                                                {
                                                    ((user.loggedInByRFID && Config.terminal.enableSignOutWithRfidButton) ||
                                                        (user.loggedIn && !user.loggedInByRFID)) &&
                                                    <li className="logout-v" onClick={this.logOut()}>{t("SIGN OUT")}</li>
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            }
                        </ul>
                    </div>
                    <div className="mini-naw-contain">
                        <ul>
                            {Config.enableTopGames &&
                                <li className="liveClock">
                                    <Clock format={'HH:mm'} ticking={true} />
                                </li>
                            }
                            <li className='search-in-header'>
                                {
                                    Config.searchInHeader && <SearchInheader />
                                }
                            </li>
                            {Config.disableBalanceInHeader ? null
                                : <li>
                                    <Balance />
                                </li>}
                            {
                                Config.disableCashoutInHeader ? null
                                    : !user.loggedIn && <li>
                                        <div className="single-nav-item" onClick={this.openCashoutPopup}>
                                            <p>{t("Cash out")}</p>
                                        </div>
                                    </li>
                            }
                            {Config.enableDepositMoney && ![DepositModeEnum.Cash, DepositModeEnum.None].includes(depositMode) &&
                                <li>
                                    <div className="single-nav-item" onClick={this.props.openPopup("depositMoney")}>
                                        <p>{t("DEPOSIT BY BANK CARD")}</p>
                                    </div>
                                </li>
                            }
                            {
                                !Config.terminal.disableTicket && <li onClick={this.props.openPopup("ticketInManualCheck")}>
                                    <div className="single-nav-item">
                                        <button className="button-view-t">{t("TICKET")}</button>
                                    </div>
                                </li>
                            }
                        </ul>
                    </div>
                    {
                        Config.runtimeOddsFormatDropdow &&
                        <div className='odds-format-container'>
                            <p>{t("Odds Format")}</p>
                            <OddsSelector />
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>;
}
